




























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { BPopover, BvEvent } from "bootstrap-vue";
import { formatPhone } from "@/utils";

@Component({
  components: {
    BPopover,
  },
  computed: mapGetters("schedule", ["checkedRows", "notRemindedRows"]),
})
export default class RemindersPopover extends Vue {
  @Prop(Boolean) readonly show!: boolean;
  id = "reminders-popover";
  checkedRows!: any[];
  loading = false;
  get target() {
    return this.id + "-target";
  }
  sendCalls() {
    this.$modal.show("dialog", {
      title: "SEND <b>CALL</b> REMINDERS",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/sendApptCall",
                    id
                  );
                  if (result.includes("ERROR SENDING VOICE")) {
                    const error = result.split(":")[1].trim();
                    appt.reminder.error = error;
                  } else {
                    appt.reminder.sent = true;
                    appt.messageType= "CALL";
                  }
                } catch (error) {
                  appt.reminder.error = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  sendTexts() {
    this.$modal.show("dialog", {
      title: "SEND <b>TEXT</b> REMINDERS",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/sendApptSMS",
                    id
                  );
                  var Jresult = JSON.parse(result.replace("OK:", ""));
                  if (result.includes("ERROR SENDING")) {
                    //const error = result.split(":")[1].trim();
                    appt.reminder.error = Jresult["message"];
                  } else {
                    appt.reminder.sent = true;
                    appt.messageType= Jresult["type"];
                  }
                } catch (error) {
                  appt.reminder.error = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  sendSMS() {
    this.$modal.show("dialog", {
      title: "SEND <b>SMS</b> REMINDERS",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/sendApptMessageSMS",
                    id
                  );
                  var Jresult = JSON.parse(result.replace("OK:", ""));
                  if (result.includes("ERROR SENDING")) {
                    //const error = result.split(":")[1].trim();
                    appt.reminder.error = Jresult["message"];
                  } else {
                    appt.reminder.sent = true;
                    appt.messageType= Jresult["type"];
                  }
                } catch (error) {
                  appt.reminder.error = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  sendEmails() {
    this.$modal.show("dialog", {
      title: "SEND <b>EMAIL</b> REMINDERS",
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$modal.hide("dialog");
            this.loading = true;
            try {
              const { checkedRows } = this;
              for (let i = 0; i < checkedRows.length; i++) {
                const appt = checkedRows[i];
                const { id } = appt;
                try {
                  const result: string = await this.$store.dispatch(
                    "schedule/sendApptEMAIL",
                    id
                  );
                  if (result.includes("ERROR SENDING SMS")) {
                    const error = result.split(":")[1].trim();
                    appt.reminder.error = error;
                  } else {
                    appt.reminder.sent = true;
                    appt.messageType='EMAIL';
                  }
                } catch (error) {
                  appt.reminder.error = error.response.data;
                }
              }
            } catch (error) {
              console.log(error);
            } finally {
              this.loading = false;
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  close() {
    if (this.loading) return;
    this.$root.$emit("bv::hide::popover", this.id);
    this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
  }
  hide(e: BvEvent) {
  if (this.loading) e.preventDefault();
    //this.$store.commit("schedule/UNCHECK_PAGE_ROWS");
    console.log("REMINDERS_HIDDEN");
  }
  get formatPhone() {
    return formatPhone;
  }
  mounted() {}
}
